import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { routes, apiResourceEndpoint } from '../../constants/routes'
import { fetchApiDataIfNeeded, callApi } from '../../actions/api'
import { handleSignOut } from '../../actions/auth'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouterProps } from '../utils/with-router-props'
import Error from './error'

const mapStateToProps = (state) => {
    return {
        account: state.get('account'),
        auth: state.get('auth'),
        role: state.get('role'),
        user: state.get('user'),
        ui: state.get('ui')
    }
}

const AuthRouter = ({ dispatch, location, account, auth, role, user, ui }) => {
    const [ readyToRoute, setReadyToRoute ] = React.useState(false)
    const [ onboardStatus, setOnboardStatus ] = React.useState('')
    const [ stripeRequest, setStripeRequest ] = React.useState(false)
    const [ hasTimedOut, setHasTimedOut ] = React.useState(false)
    const [ hasAuthError, setHasAuthError ] = React.useState(false)
    const accountTypeName = account.getIn(['_computed', 'accountTypeName']) ?? ''

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('users/load-details', 'LIST')))
    }, [dispatch])

    useEffect(() => {
        const timer = setTimeout(() => {
            setHasTimedOut(true)
        }, 5000)
        return () => clearTimeout(timer)
    }, [])


    useEffect(() => {
        if (auth && auth.has('authEmail')) {
            // Check for auth related errors
            if (ui.has('authProviderErrors') && Array.isArray(ui.get('authProviderErrors')) && ui.get('authProviderErrors').length > 0) {
                if (hasAuthError !== true) {
                    setHasAuthError(true)
                }
            } else if (user && user.has('id')) {
                const userId = user.get('id')
                if (userId === -1) {
                    setOnboardStatus('CREATE_USER')
                } else if (role && role.has('name')) {
                    if (user.has('accountId') && user.get('accountId') > 0) {
                        if (account && account.get('stripeCustomer')) {
                            if (account.hasIn(['_computed', 'subscriptionStatusValue']) && account.getIn(['_computed', 'subscriptionStatusValue']) === 'ACTIVE') {
                                setReadyToRoute(true)
                            } else {
                                setOnboardStatus('CREATE_SUBSCRIPTION')
                            }
                        } else if (!stripeRequest) {
                            setStripeRequest(true)
                            dispatch(callApi(apiResourceEndpoint('accounts', 'CREATE', null, 'stripe'), {}, -1))
                        }
                    } else {
                        setOnboardStatus('CREATE_ACCOUNT')
                    }
                }
            }
        }
    }, [dispatch, auth, user, role, account, ui])

    const renderContent = () => {
        if (hasAuthError) {
            const errors = ui.get('authProviderErrors')
            return <Error errors={errors} />
        }

        if (hasTimedOut) {
            return (<>
                <h1 className="m-5 text-center">Something Went Wrong</h1>
                <p className="m-5 text-center">
                    <span onClick={() => dispatch(handleSignOut())} className="btn blue">
                        Back to Login
                    </span>
                </p>
            </>)
        }

        return (<>
            <FontAwesomeIcon icon="spinner" spin />
            <h1 className="m-5 text-center">Heading to Your Account...</h1>
        </>)
    }


    if (readyToRoute) {
        if (location.state && location.state.from && location.state.from.pathname) {
            return <Navigate to={location.state.from.pathname + (location.state.from.search || '')} />
        }
        if (accountTypeName === 'Whitelabel') {
            return <Navigate to={routes.whitelabelIndex.path} />
        }
        return <Navigate to={routes.ndaIndex.path} />
    }
    switch (onboardStatus) {
    case 'CREATE_USER':
        return <Navigate to={routes.authCreateUser.path} />
    case 'CREATE_ACCOUNT':
        return <Navigate to={routes.authCreateAccount.path} />
    case 'CREATE_SUBSCRIPTION':
        return <Navigate to={routes.authCreateSubscription.path} />
    default:
        return (<>
            <div id="app-wrapper">
                <div id="content">
                    <div className="container">
                        <div className="row mt-4">
                            <div className="box m-auto text-center">
                                <span className="large-status-icon">
                                    {renderContent()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }
}

export default withRouterProps(connect(mapStateToProps)(AuthRouter))
